export enum OrderGenerationAlgorithm {
  CODE_ORDER_GENERATION_ALGORITHM_SEQUENTIAL = 'SEQUENTIAL',
  CODE_ORDER_GENERATION_ALGORITHM_ALPHANUMERIC_RANDOM = 'ALPHANUMERIC_RANDOM',
  CODE_ORDER_GENERATION_ALGORITHM_CUSTOM= 'CUSTOM',
  CODE_ORDER_GENERATION_ALGORITHM_ISO6461991_RANDOM = 'ISO6461991_RANDOM',
  CODE_ORDER_GENERATION_ALGORITHM_LIMITED_EDITION = 'LIMITED_EDITION'
}
